// eslint-disable-next-line no-useless-escape
export const emailRegexp = /^[a-zA-Z0-9\_*\-*\.*]+@[a-zA-Z0-9\-*]+\.*[A-Za-z\.*\-*]*\.[A-Za-z]+$/;

export const siteRegexp = /\b(?:https?:\/\/)?(?:www\.)?\w+\.(?:com|in|org)\b/;

export const hrmsSiteRegexp = /^(https?:\/\/)?((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,}$/;

// export const siteRegexp = /.+\..+/;

// export const passwordRegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*\W).+$/;
export const passwordRegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).+$/;

export const cinRegexp = /^([L|U|C|F]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6})$/;

export const gstRegexp = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

export const mobileMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

export const yearMask = [/[1-2]/, /\d/, /\d/, /\d/];

export const aadharMask = [
    'X',
    'X',
    'X',
    'X',
    ' ',
    'X',
    'X',
    'X',
    'X',
    ' ',
    'X',
    'X',
    'X',
    'X',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];

export const spaceRegexp = /^[A-Za-z][\d\s(\-']{1,5}$/;
export const eSignatureNameRegexp = /^[A-Za-z ]+$/;
